import { Button, Card, Divider, Drawer, Form, Input, message, Space } from 'antd';
import React, { useContext, useEffect } from 'react';
import Markdown from 'react-markdown';
import remarkDirective from 'remark-directive';
import remarkDirectiveSugar from 'remark-directive-sugar';
import { usePageServicePostBackendv2Page } from '../../backendapi/queries';
import { PageDto } from '../../backendapi/requests';
import { ConfigContext } from '../../contexts/ConfigContext';

const CreatePage: React.FC<{ isOpen: boolean, onClose: () => void }> = ({ isOpen, onClose }) => {

    const { currentClient } = useContext(ConfigContext)
    const {mutateAsync: createPage, isPending, isSuccess, isError, error } = usePageServicePostBackendv2Page();
    
    const [form] = Form.useForm<PageDto>();
    const [messageApi, contextHolder] = message.useMessage();
    const content = Form.useWatch('content', form);

    const onSubmit = () => {
        form.submit();
    };

    const onFinish = async () => {
        const values = form.getFieldsValue(true) as PageDto;
        values.clientId = currentClient.id;
        await createPage({requestBody: values});
    };

    useEffect(() => {
        if(isSuccess){
            messageApi.success("page created");
            onClose();
        }
    }, [isSuccess, messageApi, onClose]);

    useEffect(() => {
        if(isError){
            messageApi.error(error?.toString());
        }
    }, [error, isError, isSuccess, messageApi]);

    return (
        <>
            {contextHolder}

            <Drawer
                title="Create a new page"
                size={1200}
                onClose={onClose}
                open={isOpen}
                extra={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={isPending}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}>
                        
                    <Form.Item rules={[{ required: true }]} name='name' label="Name">
                        <Input />
                    </Form.Item>

                    <Form.Item rules={[{required: true}]} name='content' label="Content">
                        <Input.TextArea rows={16} />
                    </Form.Item>

                    <h3>Preview</h3>
                    <Divider />

                    <Card>
                        <div id="createapp" style={{maxHeight: 500, minHeight: 0, overflow: 'auto'}}>
                            <div className='page-wrapper'>
                                <Markdown remarkPlugins={[remarkDirective, remarkDirectiveSugar]}>{content}</Markdown>
                            </div>
                        </div>
                    </Card>
                </Form>
            </Drawer>
        </>

    );
};

export default CreatePage;